/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import Img from '../../components/Img';
import { drawCategoryTypeIds, sportTypeIds } from '../../utils/eventConstants';
import * as drawEditActions from '../../actions/draw-edit-actions';
import PrintMatchSheetModal from './PrintMatchSheetModal';
import PopOverMenu from '../../components/PopOverMenu';
import { EventDeskTabKeys } from '../../utils/eventDeskConstants';
import styles from './drawEdit.scss';
import { PRINT_ALL_MATCHES } from '../MatchScorePrintPage/config';

const DrawsHeaderV2 = (props) => {
    const { draw, isReadOnly, isLocked, drawName, drawCatType, parentDraw, showDrawEditModal, toPrintPage, toMedalReportPrintPage, eventId, toSchedulePage, description, handleSaveClick, showErrorPopup, showPublishModal, closeClickHandler, activeView, PTTError, handleEditClick, unsavedChanges, handleDiscardChanges, noDrawsYet, sportTypeId, eventName, hideNavBar, occupyFullWidth, containerClass = '' } = props;
    const { isSaving, isSaved } = useSelector(({ drawEdit }) => {
        const { isSaving, isSaved } = drawEdit;
        return { isSaving, isSaved };
    });
    const dispatch = useDispatch();
    const [showPrintMatchSheetModal, setShowPrintMatchSheetModal] = useState(false);

    const handleSave = (action, actionType) => {
        if (PTTError) {
            showErrorPopup({
                message: `Error ${actionType} draws`,
                error: 'Players are mapped to more than one draw number. Correct player placement in all rounds.',
            });
        } else {
            action();
        }
    };
    const isParentDraw = parentDraw?.id === draw.id;
    const isGroupDraw = parentDraw?.categoryTypeId === drawCategoryTypeIds.GROUPED;

    const popoverMenuItems = [];
    const isPickleballEvent = sportTypeId === sportTypeIds.PICKLEBALL;

    popoverMenuItems.push({ value: 'printDraws', label: 'Print draws' });

    if (isPickleballEvent) {
        popoverMenuItems.push({ value: 'printScoreSheets', label: 'Print score sheets' });
        popoverMenuItems.push({ value: 'printMedalReport', label: 'Print medal report' });
    }

    const closeModal = () => {
        setShowPrintMatchSheetModal(false);
    };

    const showPrintPopUp = () => {
        setShowPrintMatchSheetModal(true);
    };

    const printMatchSheet = (matchId, formValues) => {
        // Call update draws/match API for saving isPrinted
        if (formValues.markPrinted) {
            dispatch(drawEditActions.printMatchSheet({ reload: true, matchId }));
        }
        setShowPrintMatchSheetModal(false);
        // Redirect to matchsheet print page with above matchId and formValues
        const { id, scoringTypeId } = draw;
        const drawId = id;
        const { scoreSheetType, pageFormat } = formValues;
        if (window) {
            window.open(`/events/${eventId}/draws/${drawId}/print-matches?matchId=${PRINT_ALL_MATCHES}&scoringFormat=${scoringTypeId}&scoreSheetType=${scoreSheetType}&pageFormat=${pageFormat}`, '_blank');
        } else {
            props.history.push(`/events/${eventId}/draws/${drawId}/print-matches?matchId=${PRINT_ALL_MATCHES}&scoringFormat=${scoringTypeId}&scoreSheetType=${scoreSheetType}&pageFormat=${pageFormat}`);
        }
    };

    const handleScorePopoverClick = (item) => {
        const itemValue = item.value;
        if (itemValue === 'printDraws') {
            toPrintPage();
        } else if (itemValue === 'printScoreSheets') {
            showPrintPopUp();
        } else if (itemValue === 'printMedalReport') {
            toMedalReportPrintPage();
        } else {
            // For Sonar
        }
    };

    return (
        <>
            <div className={styles.drawsHeaderNavbar}>
                <div className={`${containerClass} ${occupyFullWidth ? 'pl24 pr24' : 'container'}  ${styles.flexSpaceBetween}`}>
                    <div data-testid="draw-edit.header.event-name">{`Event desk: ${eventName}`}</div>
                    <div className="close-area ml16" onClick={closeClickHandler} data-testid="draw-edit.header.close-btn">
                        <Img className="close-icon" src="/img/icons/close-icon-lg.svg" />
                    </div>
                </div>
            </div>
            {!hideNavBar && (
                activeView !== EventDeskTabKeys.PLAYERS_TAB && (
                <div className="navbar bb mt0" style={{ height: 'auto' }}>
                    <div className={`container pb0`} style={{ position: 'relative', height: 'auto' }}>
                        <div className="col">
                            {!noDrawsYet && (
                                <div className="draws-title">
                                    <div className={styles.flexSpaceBetweenSub}>
                                        <div className={`fs14 fw600 ${styles.drawHeader} ${styles.widthWordWrap}`} data-testid="draw-edit.header.draw-name">
                                            {drawName}{drawCatType && <span className="fw400 text-capitalize text-lighter">&nbsp;&bull;&nbsp;{drawCatType}</span>}
                                            <p className="mb0 fw400" data-testid="draw-edit.header.description">
                                                {description} {unsavedChanges && activeView === EventDeskTabKeys.DRAW_EDITOR ? <span className="text-danger text-medium"><i className="far fa-exclamation-circle" />&nbsp;Unsaved changes!</span> : null}
                                            </p>
                                        </div>

                                        <div className={`d-flex text-center ${styles.flexCenter} ${styles.drawHeader} ${styles.flexWrap}`}>
                                            <div className={` m-1 ${styles.flexCenter}`}>
                                                {draw.canEditDraw && !isReadOnly && activeView === EventDeskTabKeys.DRAW_EDITOR && (
                                                    <span className={`text-lighter ${styles.mx1}`}>
                                                        <span
                                                            className="text-teal cursor-pointer"
                                                            onClick={() => showDrawEditModal()}
                                                            data-testid="draw-edit.header.edit-btn"
                                                        >
                                                            <Img className="close-icon" src="/img/icons/edit-icon-dh.svg" />
                                                        </span>
                                                    </span>
                                                )}
                                                {isPickleballEvent && !isReadOnly && activeView === EventDeskTabKeys.DRAW_EDITOR && (
                                                    <span className={`text-lighter ${styles.mx1}`}>
                                                        <PopOverMenu
                                                            popOverMenuClass="float-right"
                                                            menuItems={popoverMenuItems}
                                                            onSelected={handleScorePopoverClick}
                                                            data-testid="draw-edit.header.print-menu"
                                                        >
                                                            <span className={`text-teal cursor-pointer ${styles.flexCenter}`}>
                                                                <Img className="close-icon" src="/img/icons/print-icon-dh.svg" /> <i className="uts uts-expand" />
                                                            </span>
                                                        </PopOverMenu>
                                                    </span>
                                                )}
                                                {(!isPickleballEvent && (isParentDraw || isGroupDraw)) && !isReadOnly && activeView === EventDeskTabKeys.DRAW_EDITOR && (
                                                    <span className={`text-medium text-lighter ${styles.mx1}`}>
                                                        <span className="text-teal cursor-pointer" onClick={() => toPrintPage()} data-testid="draw-edit.header.print-btn">
                                                            <Img className="close-icon" src="/img/icons/print-icon-dh.svg" />
                                                        </span>
                                                    </span>
                                                )}
                                                {activeView === EventDeskTabKeys.DRAW_EDITOR && (
                                                    <span className={`text-medium text-lighter ${styles.mx1}`}>
                                                        <span className="text-teal cursor-pointer" onClick={() => toSchedulePage()} data-testid="draw-edit.header.schedule-btn">
                                                            <Img className="close-icon" src="/img/icons/schedule-icon-dh.svg" />
                                                        </span>
                                                    </span>
                                                )}
                                            </div>
                                            {isReadOnly ? (
                                                <div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-default btn-lg text-uppercase ml16"
                                                        onClick={handleEditClick}
                                                        disabled={isLocked}
                                                        data-testid="draw-edit.header.edit-mode-btn"
                                                    >
                                                        <Img className="close-icon" src="/img/icons/edit-icon-dh.svg" />
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className={`m-1 ${styles.flexAlignCenter}`}>
                                                    {!noDrawsYet && unsavedChanges && activeView === EventDeskTabKeys.DRAW_EDITOR && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-default btn-sm text-uppercase ml16"
                                                            onClick={handleDiscardChanges}
                                                            data-testid="draw-edit.header.discard-btn"
                                                        >
                                                            Discard
                                                        </button>
                                                    )}
                                                    {!noDrawsYet && (
                                                        <>
                                                            {(!unsavedChanges) ? (
                                                                <button
                                                                    type="button"
                                                                    className="btn p0 pl5"
                                                                    data-testid="draw-edit.header.saved-status"
                                                                >
                                                                    <span className={styles.greenDot} />
                                                                    Saved
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className={`btn btn-primary btn-sm text-uppercase ml16 ${isSaved ? 'success' : ''}`}
                                                                    onClick={() => handleSave(handleSaveClick, 'saving')}
                                                                    data-testid="draw-edit.header.save-btn"
                                                                >
                                                                    {isSaving &&
                                                                        <span className="small"><i className="fas fa-circle-notch fa-spin" />&nbsp;Saving...</span>}
                                                                    {isSaved && <>Saved</>}
                                                                    {!isSaving && !isSaved && <>Save</>}
                                                                </button>
                                                            )}
                                                            {!unsavedChanges && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm text-uppercase ml16"
                                                                    onClick={() => handleSave(showPublishModal, 'publishing')}
                                                                    data-testid="draw-edit.header.publish-btn"
                                                                >
                                                                    Publish
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
                )
            )}
            {showPrintMatchSheetModal && (
                <PrintMatchSheetModal
                    printMatchSheet={printMatchSheet}
                    closeModals={closeModal}
                />
            )}

        </>
    );
};

DrawsHeaderV2.propTypes = {
    draw: PropTypes.objectOf(any).isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    isLocked: PropTypes.bool.isRequired,
    drawName: PropTypes.string,
    drawCatType: PropTypes.string,
    parentDraw: PropTypes.objectOf(any),
    showDrawEditModal: PropTypes.func,
    toPrintPage: PropTypes.func,
    toMedalReportPrintPage: PropTypes.func,
    eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    toSchedulePage: PropTypes.func,
    description: PropTypes.string,
    handleSaveClick: PropTypes.func,
    showErrorPopup: PropTypes.func,
    showPublishModal: PropTypes.func,
    closeClickHandler: PropTypes.func.isRequired,
    activeView: PropTypes.string,
    PTTError: PropTypes.objectOf(any),
    handleEditClick: PropTypes.func,
    unsavedChanges: PropTypes.bool,
    handleDiscardChanges: PropTypes.func,
    noDrawsYet: PropTypes.bool,
    sportTypeId: PropTypes.number.isRequired,
    eventName: PropTypes.string.isRequired,
    history: PropTypes.objectOf(any),
    hideNavBar: PropTypes.bool,
    occupyFullWidth: PropTypes.bool,
};

DrawsHeaderV2.defaultProps = {
    drawName: '',
    drawCatType: '',
    parentDraw: {},
    showDrawEditModal: () => { },
    toPrintPage: () => { },
    toMedalReportPrintPage: () => { },
    eventId: null,
    toSchedulePage: () => { },
    description: '',
    handleSaveClick: () => { },
    showErrorPopup: () => { },
    showPublishModal: () => { },
    activeView: '',
    PTTError: null,
    handleEditClick: () => { },
    unsavedChanges: false,
    handleDiscardChanges: () => { },
    noDrawsYet: false,
    history: {},
    hideNavBar: false,
    occupyFullWidth: false,
};

export default DrawsHeaderV2;
